import {
  FETCH_SUBSCRIPTION_PLANS,
  FETCH_SUBSCRIPTION_PLANS_SUCCESS,
  FETCH_SUBSCRIPTION_PLANS_FAILED,
  FETCH_USER_SUBSCRIPTION,
  FETCH_USER_SUBSCRIPTION_SUCCESS,
  FETCH_USER_SUBSCRIPTION_FAILED,
  CREATE_SUBSCRIPTION,
  CREATE_SUBSCRIPTION_SUCCESS,
  CREATE_SUBSCRIPTION_FAILED,
  CHECK_TRIP_USAGE,
  CHECK_TRIP_USAGE_SUCCESS,
  CHECK_TRIP_USAGE_FAILED,
  FETCH_SUBSCRIPTION_STATS,
  FETCH_SUBSCRIPTION_STATS_SUCCESS,
  FETCH_SUBSCRIPTION_STATS_FAILED,
  VERIFY_OFFLINE_PAYMENT,
  VERIFY_OFFLINE_PAYMENT_SUCCESS,
  VERIFY_OFFLINE_PAYMENT_FAILED,
  CLEAR_SUBSCRIPTION_ERROR
} from "../store/types";

const INITIAL_STATE = {
  // Subscription Plans
  plans: {},
  plansLoading: false,
  plansError: null,

  // User Subscription
  userSubscription: null,
  userSubscriptionLoading: false,
  userSubscriptionError: null,

  // Create Subscription
  createSubscriptionLoading: false,
  createSubscriptionError: null,
  createSubscriptionSuccess: null,

  // Trip Usage
  tripUsage: null,
  tripUsageLoading: false,
  tripUsageError: null,

  // Subscription Statistics (for admin)
  stats: null,
  statsLoading: false,
  statsError: null,

  // Verify Offline Payment
  verifyPaymentLoading: false,
  verifyPaymentError: null,
  verifyPaymentSuccess: null,

  // General error state
  error: null
};

export const subscriptionreducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // Fetch Subscription Plans
    case FETCH_SUBSCRIPTION_PLANS:
      return {
        ...state,
        plansLoading: true,
        plansError: null
      };
    case FETCH_SUBSCRIPTION_PLANS_SUCCESS:
      return {
        ...state,
        plans: action.payload.plans,
        plansLoading: false,
        plansError: null
      };
    case FETCH_SUBSCRIPTION_PLANS_FAILED:
      return {
        ...state,
        plans: {},
        plansLoading: false,
        plansError: action.payload
      };

    // Fetch User Subscription
    case FETCH_USER_SUBSCRIPTION:
      return {
        ...state,
        userSubscriptionLoading: true,
        userSubscriptionError: null
      };
    case FETCH_USER_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        userSubscription: action.payload,
        userSubscriptionLoading: false,
        userSubscriptionError: null
      };
    case FETCH_USER_SUBSCRIPTION_FAILED:
      return {
        ...state,
        userSubscription: null,
        userSubscriptionLoading: false,
        userSubscriptionError: action.payload
      };

    // Create Subscription
    case CREATE_SUBSCRIPTION:
      return {
        ...state,
        createSubscriptionLoading: true,
        createSubscriptionError: null,
        createSubscriptionSuccess: null
      };
    case CREATE_SUBSCRIPTION_SUCCESS:
      return {
        ...state,
        userSubscription: action.payload,
        createSubscriptionLoading: false,
        createSubscriptionError: null,
        createSubscriptionSuccess: 'Subscription created successfully'
      };
    case CREATE_SUBSCRIPTION_FAILED:
      return {
        ...state,
        createSubscriptionLoading: false,
        createSubscriptionError: action.payload,
        createSubscriptionSuccess: null
      };

    // Check Trip Usage
    case CHECK_TRIP_USAGE:
      return {
        ...state,
        tripUsageLoading: true,
        tripUsageError: null
      };
    case CHECK_TRIP_USAGE_SUCCESS:
      return {
        ...state,
        tripUsage: action.payload,
        tripUsageLoading: false,
        tripUsageError: null,
        // Update user subscription if trip usage data is included
        userSubscription: action.payload.tripsUsed !== undefined && state.userSubscription ? {
          ...state.userSubscription,
          tripsUsed: action.payload.tripsUsed,
          status: action.payload.limitReached ? 'limit_reached' : state.userSubscription.status
        } : state.userSubscription
      };
    case CHECK_TRIP_USAGE_FAILED:
      return {
        ...state,
        tripUsage: null,
        tripUsageLoading: false,
        tripUsageError: action.payload
      };

    // Fetch Subscription Statistics
    case FETCH_SUBSCRIPTION_STATS:
      return {
        ...state,
        statsLoading: true,
        statsError: null
      };
    case FETCH_SUBSCRIPTION_STATS_SUCCESS:
      return {
        ...state,
        stats: action.payload,
        statsLoading: false,
        statsError: null
      };
    case FETCH_SUBSCRIPTION_STATS_FAILED:
      return {
        ...state,
        stats: null,
        statsLoading: false,
        statsError: action.payload
      };

    // Verify Offline Payment
    case VERIFY_OFFLINE_PAYMENT:
      return {
        ...state,
        verifyPaymentLoading: true,
        verifyPaymentError: null,
        verifyPaymentSuccess: null
      };
    case VERIFY_OFFLINE_PAYMENT_SUCCESS:
      return {
        ...state,
        verifyPaymentLoading: false,
        verifyPaymentError: null,
        verifyPaymentSuccess: action.payload
      };
    case VERIFY_OFFLINE_PAYMENT_FAILED:
      return {
        ...state,
        verifyPaymentLoading: false,
        verifyPaymentError: action.payload,
        verifyPaymentSuccess: null
      };

    // Clear Error
    case CLEAR_SUBSCRIPTION_ERROR:
      return {
        ...state,
        error: null,
        plansError: null,
        userSubscriptionError: null,
        createSubscriptionError: null,
        tripUsageError: null,
        statsError: null,
        verifyPaymentError: null,
        createSubscriptionSuccess: null,
        verifyPaymentSuccess: null
      };

    default:
      return state;
  }
}; 